const baseStyle = {
  title: {
    fontWeight: 600,
  },
}

export default {
  baseStyle,
}
